/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Add Content Icon
 *
 * @file AddContentIcon.jsx
 * @author Gladson Samuel S
 * @since 2.0.0
 */

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import PropTypes from 'prop-types';

const AddContentIcon = ({ className }) => (
  <SvgIcon className={className} xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
    <path d="M6.44824 0C6.88547 4.21468e-08 7.24023 0.354767 7.24023 0.791992V5.65723H12.1055C12.5426 5.65728 12.8973 6.01117 12.8975 6.44824C12.8975 6.88544 12.5427 7.24019 12.1055 7.24023H7.24023V12.1055C7.24018 12.5426 6.88543 12.8975 6.44824 12.8975C6.01118 12.8973 5.65728 12.5426 5.65723 12.1055V7.24023H0.791992C0.354767 7.24023 0 6.88547 0 6.44824C0.000148914 6.01114 0.354858 5.65723 0.791992 5.65723H5.65723V0.791992C5.65723 0.35486 6.01115 0.00015132 6.44824 0Z" fill="#0D004D" />
  </SvgIcon>
);

AddContentIcon.propTypes = {
  className: PropTypes.string
};

AddContentIcon.defaultProps = {
  className: ''
};

export default AddContentIcon;
